/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';
import { BreakPoint, Color } from '../../../../asset/styles';

const StyledHeader = styled.div`
  background-color: ${Color.white};
  box-sizing: border-box;
  color: ${Color.text.black};
  height: ${props => props.headerHeight + 32}px;
  padding: 16px 16px 0 16px;
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1001;

  /* margin-top for HeaderCloseBar */
  margin-top: ${props => props.marginTop}px;

  @media (min-width: ${BreakPoint.desktop}) {
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    position: relative;
    width: 456px;
    margin-bottom: 0;
  }
`;

const StyledHeaderBox = styled.div`
  box-sizing: border-box;
  /*
  20200120
  height: ${props => props.headerHeight + 8}px;
  */
  overflow: hidden;
`;

const StyledHeadLine = styled.div`
  display: flex;
  align-items: start;
  justify-content: flex-end;
`;

/**
 * {@Link Inquiry} - header container
 * @param {number} headerHeight {@link HeaderMessage} clientHeight
 * @param {number} marginTop margin-top value(px)
 * @param {boolean} isFullscreen full screen flag
 * @param {*} props React.props
 * @return {*} Header container を返します
 * @constructor
 */
const Header = ({ headerHeight, marginTop = 1, isFullscreen, ...props }) => (
  <StyledHeader
    className={'Header'}
    headerHeight={headerHeight}
    marginTop={marginTop}
    isFullscreen={isFullscreen}
  >
    <StyledHeaderBox headerHeight={headerHeight}>
      <StyledHeadLine>{props.children}</StyledHeadLine>
    </StyledHeaderBox>
  </StyledHeader>
);

export default Header;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/header/Header.js